import { render, staticRenderFns } from "./AdminConfigContainer.vue?vue&type=template&id=f43ea10c&scoped=true"
import script from "./AdminConfigContainer.vue?vue&type=script&lang=js"
export * from "./AdminConfigContainer.vue?vue&type=script&lang=js"
import style0 from "./AdminConfigContainer.vue?vue&type=style&index=0&id=f43ea10c&prod&scoped=true&lang=css"
import style1 from "./AdminConfigContainer.vue?vue&type=style&index=1&id=f43ea10c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43ea10c",
  null
  
)

export default component.exports